import { Action, Reducer } from 'redux';
import {
  CartStatusState,
  CartStatusTypes,
  CartStatusActionTypes
} from './cartStatusTypes';

export const INITIAL_STATE: CartStatusState = {
  cartStatus: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const cartStatusReducer: Reducer<CartStatusState> = (
  state: CartStatusState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as CartStatusActionTypes;
  switch (actionTypes.type) {
    case CartStatusTypes.GET_CART_STATUS:
      return {
        ...state,
        cartStatus: { ...state.cartStatus, isLoading: true }
      };
    case CartStatusTypes.SAVE_CART_STATUS:
      return {
        ...state,
        cartStatus: {
          ...state.cartStatus,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case CartStatusTypes.RESET_REDUCER_CART_STATUS:
      return {
        ...state,
        cartStatus: INITIAL_STATE.cartStatus
      };
    default:
      return state;
  }
};

export default cartStatusReducer;
